import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/loading',
      name: 'loading',
      component: () => import('../pages/Loading/Loading.vue')
    },
    {
      path: '/select',
      name: 'select',
      component: () => import('../pages/Auth/Select.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../pages/Auth/Login.vue')
    },
    {
      path: '/confirm',
      name: 'confirm',
      component: () => import('../pages/Auth/Confirm.vue')
    },
    {
      path: '/request',
      name: 'request',
      component: () => import('../pages/Request/Request.vue')
    },
    {
      path: '/history',
      name: 'history',
      component: () => import('../pages/History/History.vue')
    },
    {
      path: '/payment/result',
      name: 'payment-result',
      component: () => import('../pages/PaymentResult/PaymentResult.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/request'
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (!from.name) {
    const initialUrl = window.location.href;
    sessionStorage.setItem('initialUrl', initialUrl);
  }

  const token = localStorage.getItem('token');
  const isTourist = localStorage.getItem('tourist') === '1';

  if (to.name === 'select' || to.name === 'login' || to.name === 'confirm') {
    return next();
  }

  if (!token && !isTourist) {
    localStorage.setItem('tourist', '1');
    return next();
  }

  if (token || isTourist) {
    return next();
  }

  return next({ name: 'request' });
});

export default router;
